import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import ElementComponent from '../../../Component/UI/Element';

export class Heartbeat extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: { duration: number }
    ): IterableIterator<number> {
        const element = gameObject.getComponent(ElementComponent);
        const tween = this.getTween(element.layout.scale);

        element.layout.scale[0] = 0.5;
        element.layout.scale[1] = 0.5;

        tween
            .to({ 0: 0.6, 1: 0.6 }, meta.duration)
            .yoyo(true)
            .repeat(Infinity)
            .easing(Easing.Quadratic.InOut)
            .start(this.elapsedTime);

        // Loop.
        while (true) yield;
    }
}
